import * as Yup from 'yup';

const matcherGenericCheckboxSchema = Yup.object().test(
  'atLeastOneRequired',
  'Please choose at least one option to continue.',
  (value) => {
    if (!value) {
      return false;
    }
    return Object.values(value).some((v) => v !== false);
  }
);

export { matcherGenericCheckboxSchema };
